class PartnersSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            cellSelector: '.partners-slider__slide'
        };

        if(this.$el.length) {
            this._createSlider();
        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }
}

export default PartnersSlider;
